<template>
    <h2 class="title">
        <slot></slot>
    </h2>
</template>

<script>
export default {
    name: "AppTitle"
}
</script>

<style lang="scss" scoped>
.title {
    font-family: 'Muller';
    font-style: normal;
    font-weight: 800;
    font-size: 120px;
    line-height: 100%;
    letter-spacing: 0.025em;
    color: #6F4C30;
    background: #FBF8F4;
    padding: 0 40px;
    @media (max-width: 1439px) {
        padding: 0;
    }
    @media (max-width: 1023px) {
        font-size: 100px;
    }
    @media (max-width: 767px) {
        font-size: 80px;
    }
    @media (max-width: 479px) {
        font-size: 50px;
    }
}
</style>